import React from "react";
import { SHRichTextTooltip } from "@components/design-systems/sh-rich-text-tooltip";
import { ModelScreenerCellData } from "@models/model-screener/entities/modelScreenerData";

export const MSTableTooltip = React.memo(
  ({ cellData }: { cellData: ModelScreenerCellData }) => {
    const tooltip = cellData.tooltip;
    if (!tooltip) return null;

    return (
      <SHRichTextTooltip
        htmlTitle={tooltip.header}
        htmlContent={tooltip.additionalText}
        height={"fit-content"}
      />
    );
  },
);
